var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1338_877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.416 3.20887C18.9013 3.24477 13.6716 8.76163 14.0449 15.2476C14.21 18.1048 15.2904 20.5563 17.2681 22.6166C18.004 23.3848 18.0183 24.3646 17.3184 25.0179C16.6579 25.6353 15.6816 25.6209 15.0284 24.9533C12.785 22.6633 11.3816 19.9389 10.9401 16.7588C9.90273 9.26774 14.4433 2.41562 21.6795 0.498893C30.0858 -1.72652 38.5172 3.74728 39.8417 12.3546C40.5847 17.1823 39.1777 21.3747 35.8216 24.921C35.3442 25.4271 34.7592 25.5922 34.1131 25.3948C33.4813 25.201 33.108 24.7272 33.0004 24.0739C32.9034 23.496 33.1368 23.0294 33.5388 22.6202C35.2688 20.8507 36.3026 18.7329 36.6831 16.2921C37.5912 10.4845 33.6464 4.76307 27.8891 3.55704C27.0779 3.38834 26.2416 3.32732 25.4196 3.21605L25.416 3.20887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2765 25.3876C29.2801 32.9684 23.4509 39.3144 15.9025 39.9461C8.05967 40.6066 1.18601 35.1651 0.145096 27.3618C-0.479456 22.6741 0.9204 18.5822 4.18673 15.1471C4.89384 14.4041 5.88092 14.3575 6.54854 15C7.25565 15.682 7.24847 16.626 6.50547 17.4013C4.28006 19.7236 3.1853 22.4982 3.25349 25.7035C3.38989 32.0746 8.9606 37.1823 15.3102 36.7121C20.0482 36.3603 23.4545 33.9483 25.1846 29.5549C26.9362 25.1041 26.0532 20.9978 22.812 17.4443C22.2054 16.7767 22.0511 16.1306 22.3813 15.4594C22.69 14.8349 23.3576 14.4472 24.0611 14.598C24.4272 14.6769 24.8149 14.8887 25.0805 15.1543C27.7653 17.8571 29.2765 21.5721 29.2765 25.3912V25.3876Z",
    fill: "url(#paint0_linear_1338_877)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1338_877",
    x1: 0.00152051,
    y1: 27.2756,
    x2: 29.2765,
    y2: 27.2756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89B60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F36D55"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1338_877"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.0359,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.29c6e00c25d48159872997b2af0036b0.svg";
export { ForwardRef as ReactComponent };